import {
  get,
  put,
  post,
  del,
  default as com
} from '@/common/api'

let api = {
  // 获取ip mac
  getIpMac: (medCode) => get(`${cfg.medCard.url()}/${medCode}/1/0`),
  medLogin: (medCode, para) => post(`/api/med/trade/login/${medCode}`, para),
  execTrade: (medCode, tradeCode, para) => post(`/api/med/trade/${medCode}/${tradeCode}`, para),
  medCorpuscleRegistered: (medCode, para) => post(`/api/op/med/corpuscle/registered/${medCode}`, para),
  // 查询医保类型接口
  queryMedCode: () => get(`/api/med/trade/user/setting/list`),
  // 医保字典
  queryMedDict: (types) => post(`/api/med/dict/types`, types),
  // 医保字典
  queryMedDictByType: (type) => get(`/api/md/medDict/type/${type}`),
  // 医保结算
  medSellte: (medCode, para) => post(`/api/op/med/registered/${medCode}`, para),
  // 医保结算(单据式)
  medDtSellte: (medCode, para) => post(`/api/op/med/dtRegistered/${medCode}`, para),
  // 医保退款
  medRefund: (medCode, para) => post(`/api/op/med/refund/${medCode}`, para),
  // 医保退款(单据式)
  medDtRefund: (medCode, para) => post(`/api/op/med/dtRefund/${medCode}`, para),
  // 医保冲正
  medImpact: (medCode, para) => post(`/api/op/med/impact/${medCode}`, para),
  // 获取结算单详细
  getSetlinfo: (setlId) => get(`/api/med/setlinfo/info/${setlId}`),

}
export default api
